module.exports = __webpack_public_path__ + "static/media/image_41.c221b026.png";